import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageHeaderSearchActionService } from '../../services/page-header-search-action.service';

@Component({
  selector: 'app-offboarding-portal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offboarding-portal.component.html',
  styleUrls: ['./offboarding-portal.component.scss']
})
export class OffboardingPortalComponent implements OnInit, OnDestroy {
  constructor(private router: Router, private pageHeaderService: PageHeaderSearchActionService) {}

  ngOnInit(): void {
    this.pageHeaderService.clearPageConfig();
  }

  ngOnDestroy(): void {
    this.pageHeaderService.clearPageConfig();
  }

  navigateToCollectionWithForm(): void {
    this.router.navigate(['/offboarding/collection'], { queryParams: { openForm: true } });
  }

  navigateToCollection(): void {
    this.router.navigate(['/offboarding/collection']);
  }

  navigateToTaskTemplates(): void {
    this.router.navigate(['/offboarding/task-templates']);
  }
}
